import React from 'react'
import { Helmet } from 'react-helmet'
import LockIcon from '../../asset/lock.svg'
import { LoadingPageContainer } from '../../components/PageWrapper/styles'
import LoadingPageCard from '../../components/LoadingPageCard'

const Authenticating = () => {
  const LoadingPageData = {
    centerIcon: LockIcon,
    redirectPath: '/select-account',
  }
  return (
    <LoadingPageContainer>
      <Helmet>
        <title>Loading</title>
        <link rel="icon" href="./asset/bankIcon.svg" />
      </Helmet>
      <LoadingPageCard {...LoadingPageData} />
    </LoadingPageContainer>
  )
}

export default Authenticating
